<script>
export default {
  props: {
    data: { type: Object, default: () => ({})},
  },
  data() {
    return {
      selectedChip: 10,
      processing: false,
    }
  },
  computed: {
    classObject: function(){
      return { "inactive": this.hasNoBettingValueQueue || (this.processing === true)}
    },
    hasNoBettingValueQueue: function(){
      return Object.entries(this.data.bettingQueueValue).length === 0;
    },
    isHasPreviousBet: function() {
      let hasBet = false;
      if(this.data.previousBetting.length > 0 && this.hasNoBettingValueQueue){
        hasBet = true;
      }
      // console.log('hasBet', this.data.newGame.table, this.data.previousBetting.length, this.data.previousBetting);
      return hasBet;
    }
  },
  watch: {
    hasNoBettingValueQueue: function(newVal){
      // console.log('hasNoBettingValueQueue', Object.entries(this.data.bettingQueueValue).length);
      this.processing = false;
    }
  },
  methods: {
    selectChip(chip) {
      this.selectedChip = chip;
      this.$emit('handleSelectChip', {chip});
    },
    cancel() {
      if(!this.hasNoBettingValueQueue && (this.processing === false)){
        this.$emit('handleClearBetQueueValue');
      }
    },
    bet() {
      if(!this.hasNoBettingValueQueue && (this.processing === false)){
        this.processing = true;
        this.$emit('handleBetting');
      }
    },
    rebet() {
      if(this.isHasPreviousBet && (this.processing === false)){
        this.$emit('handleReBetting');
      }
    },
  },
  
}
</script>

<template>
  <div class="chip-row">
    <div class="bet-chip">
      <span class="chip chip-1"
        :class="{ active: selectedChip === 10 }"
        @click="selectChip(10)"
      >
        <span class="chip-number">10</span>
        <span class="no-stroke chip-number">10</span>
      </span>
      <span class="chip chip-50"
        :class="{ active: selectedChip === 50 }"
        @click="selectChip(50)"
      >
        <span class="chip-number">50</span>
        <span class="no-stroke chip-number">50</span>
      </span>
      <span class="chip chip-100"
        :class="{ active: selectedChip === 100 }"
        @click="selectChip(100)"
      >
        <span class="chip-number">100</span>
        <span class="no-stroke chip-number">100</span>
      </span>
      <span class="chip chip-500"
        :class="{ active: selectedChip === 500 }"
        @click="selectChip(500)"
      >
        <span class="chip-number">500</span>
        <span class="no-stroke chip-number">500</span>
      </span>
      <span class="chip chip-1k"
        :class="{ active: selectedChip === 1000 }"
        @click="selectChip(1000)"
      >
        <span class="chip-number">1000</span>
        <span class="no-stroke chip-number">1000</span>
      </span>
      <span class="chip chip-5k"
        :class="{ active: selectedChip === 5000 }"
        @click="selectChip(5000)"
      >
        <span class="chip-number">5000</span>
        <span class="no-stroke chip-number">5000</span>
      </span>
      <span class="chip chip-max"
        :class="{ active: selectedChip === 0 }"
        @click="selectChip(0)"
      />
      <div class="bet-confirm">
        <div
          class="btn-cancel"
          :class="classObject"
          @click="cancel"
        >
          {{ $t('cancel_bet')}}
        </div>
        <div
          v-if="isHasPreviousBet"
          class="btn-confirm active"
          @click="rebet"
        >
          {{ $t('rebet')}}
        </div>
        <div
          v-else
          class="btn-confirm"
          :class="classObject"
          @click="bet"
        >
          {{ $t('confirm')}}
        </div>
      </div>
    </div>
  </div>
</template>
